<template>
    <div class="detail">
        <div class="banner">
            <div class="swipe-wrap">
                <van-swipe :autoplay="3000" indicator-color="white" width="100%" ref="banner">
                    <van-swipe-item v-for="(banner, b) in info.banners" :key="b">
                        <van-image
                            width="100%"
                            height="100%"
                            fit="cover"
                            :src="banner.url"
                            :alt="banner.id"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
        </div>
        <div class="title-wrap">
            <div class="left">
                <h1>{{ info.name }}</h1>
                <div class="desc">
                    <img src="@images/address-ico.png" alt="" />
                    <span>
                        教室：
                        <b class="nomarl">{{ info.address }}</b>
                    </span>
                </div>
                <div class="desc">
                    <img src="@images/clock-ico.png" alt="" />
                    <span>
                        报名时间：
                        <b>{{ info.apply_start }}-{{ info.apply_end }}</b>
                    </span>
                </div>
            </div>
            <div class="right" @click="showTips = true">
                <div class="img"><img src="@images/share-ico.png" alt="分享" /></div>
                <p>分享</p>
            </div>
        </div>
        <div class="content-wrap">
            <div class="navs">
                <a href="#desc" class="nav active"><span>课程介绍</span></a>
                <a href="#courses" class="nav"><span>目录</span></a>
            </div>
            <div class="block" id="desc">
                <div class="title">讲师</div>
                <div class="teacher-wrap">
                    <div class="teachers">
                        <div
                            class="teacher"
                            v-for="(teacher, t) in info.teachers"
                            :key="t"
                            :class="active == t ? 'active' : ''"
                            @click="active = t"
                        >
                            <van-image round :src="teacher.avatar" />
                            <p>{{ teacher.name }}</p>
                        </div>
                    </div>
                    <div class="desc" v-if="info.teachers.length > 0">
                        {{ info.teachers[active].desc }}
                    </div>
                </div>
                <div class="title">课程内容</div>
                <div class="content" v-html="info.content"></div>
            </div>
        </div>
        <div class="content-wrap" id="courses">
            <div class="block no-padding">
                <div class="title">课程目录</div>
                <div class="courses-wrap">
                    <div class="steps">
                        <div class="step" v-for="(course, c) in info.courses" :key="c">
                            <div class="no">
                                <span v-text="c + 1"></span>
                            </div>
                            <div class="center">
                                <div class="center-content">
                                    <div class="name">{{ course.name }}</div>
                                    <div class="time">
                                        {{ course.start_time_text }}-{{ course.end_time_text }}
                                    </div>
                                </div>
                                <div class="center-ico"><i></i></div>
                                <div class="center-line"></div>
                            </div>
                            <div class="right">
                                <div class="status">
                                    <img
                                        :src="
                                            require('@images/course-status-' +
                                                course.status +
                                                '.png')
                                        "
                                        alt=""
                                    />
                                    <p>{{ course.status_text }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <van-empty description="暂无任何课程" v-if="info.courses.length === 0" />
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="left">
                <span>已报名</span>
                <em>{{ info.apply }}</em>
                <span>/{{ info.total_apply }}</span>
            </div>
            <div class="btn-wrap">
                <van-button
                    type="primary"
                    @click="actionApply"
                    :class="'status-' + info.apply_status"
                >
                    {{ info.status_text }}
                </van-button>
            </div>
        </div>
        <MsgPopup ref="tips"></MsgPopup>
        <div class="wechat-alipay-tips-view" v-show="showTips" @click="showTips = false"></div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getClassesInfo, applyClasses } from '@api/classes';
import { getUserInfo } from '@api/user';
import { empty, isWeixin } from '@utils';
import MsgPopup from '@components/MsgPopup';
import toLogin from '@libs/login';
import cookie from '@utils/store/cookie';
import { wechatEvevt } from '@libs/wechat';
import { getShare } from '@api/public';
export default {
    name: 'Classes',
    components: {
        MsgPopup
    },
    data() {
        return {
            info: {
                banners: [],
                teachers: [],
                name: '',
                address: '',
                content: '',
                teacher: [],
                start_time: '',
                end_time: '',
                apply_start: '',
                apply_end: '',
                total_apply: 0,
                apply: 0,
                id: 0,
                courses: []
            },
            active: 0,
            userInfo: {
                is_auth: 0,
                locked: 0
            },
            showTips: false
        };
    },
    created() {
        this.$set(this.info, 'id', this.$route.params.id || 0);
        if (empty(this.info.id) || this.info.id <= 0)
            return this.$dialog.error('参数错误').then(() => {
                this.$router.back();
            });
    },
    computed: {
        ...mapGetters(['isLogin'])
    },
    watch: {
        $route(n) {
            if (n.name === 'Classes') {
                this.getInfo();
                this.getUserData();
            }
        }
    },
    mounted: function() {
        this.getInfo();
        this.getUserData();
    },
    methods: {
        getInfo() {
            let that = this;
            getClassesInfo(this.info.id).then(res => {
                that.$set(that, 'info', res.data);
                if (isWeixin()) {
                    let configAppMessage = {
                        desc: res.data.name,
                        title: res.data.name,
                        link: location.href,
                        imgUrl: res.data.thumb
                    };
                    wechatEvevt(
                        ['updateAppMessageShareData', 'updateTimelineShareData'],
                        configAppMessage
                    )
                        .then(res => {
                            console.log(res);
                            console.log('微信分享设置完成');
                        })
                        .catch(res => {
                            if (res.is_ready) {
                                res.wx.updateAppMessageShareData(configAppMessage);
                                res.wx.updateTimelineShareData(configAppMessage);
                            }
                        });
                }
            });
        },
        getUserData() {
            let that = this;
            if (this.isLogin) {
                getUserInfo(this.id)
                    .then(res => {
                        that.$set(that, 'userInfo', res.data);
                    })
                    .catch(() => {
                        return that.$store.commit('LOGOUT');
                    });
            }
        },
        actionApply() {
            let that = this;
            if (this.info.apply_status == 0)
                return this.$dialog.error('该课程' + this.info.status_text);
            return this.$refs.tips.show(
                2,
                '提示',
                '你将报名参与“' + this.info.name + '”报名成功之后将不能在参与其他课程',
                '确认',
                function() {
                    that.toApply();
                }
            );
        },
        toApply() {
            let that = this;
            if (this.info.apply >= this.info.total_apply) {
                return this.$refs.tips.show(0, '提示', '课程名额已满，请关注后续通知');
            }
            if (this.isLogin) {
                if (!this.userInfo.is_auth) {
                    this.$refs.tips.show(
                        0,
                        '提示',
                        '你暂未拥有报名资格，请先认证',
                        '去认证',
                        function() {
                            this.$router.push({ path: '/user/authenticate' });
                        }
                    );
                } else {
                    this.$dialog.loading('报名中...');
                    applyClasses(this.info.id)
                        .then(res => {
                            return that.$dialog.close().then(() => {
                                that.$dialog.success(res.msg).then(() => {
                                    that.getInfo();
                                });
                            });
                        })
                        .catch(err => {
                            return that.$dialog.close().then(() => {
                                that.$refs.tips.show(0, '提示', err.msg || '报名失败');
                            });
                        });
                }
            } else {
                this.$refs.tips.show(0, '提示', '请先登陆', '授权登陆', function() {
                    cookie.set('login_back_url', '/classes/' + that.info.id);
                    return toLogin();
                });
            }
        },
        setOpenShare: function() {
            if (isWeixin()) {
                getShare().then(res => {
                    var data = res.data.data;
                    var configAppMessage = {
                        desc: data.desc,
                        title: data.title,
                        link: location.href,
                        imgUrl: data.img
                    };
                    wechatEvevt(
                        ['updateAppMessageShareData', 'updateTimelineShareData'],
                        configAppMessage
                    )
                        .then(res => {
                            console.log(res);
                            console.log('微信分享设置完成');
                        })
                        .catch(res => {
                            if (res.is_ready) {
                                res.wx.updateAppMessageShareData(configAppMessage);
                                res.wx.updateTimelineShareData(configAppMessage);
                            }
                        });
                });
            }
        }
    },
    beforeDestroy() {
        this.setOpenShare();
    }
};
</script>
